module.exports = __webpack_public_path__ + "assets/laodongjie.d35c15dc.svg";